<template>
    <div>
        <Modal v-model="viewmodal"
               fullscreen
               footer-hide
               @on-cancel="cancel"
               :mask="false"
               class-name="view-contract"
               :title="$t('查看合同')">
            <div class="view-content">
                <loading v-if="loading"
                         :spintext="spintext"></loading>
                <div v-else
                     class="img-class">
                    <div v-if="!url"
                         class="no-data">
                        <nodata />
                    </div>
                    <img :src="url"
                         v-else
                         @click="viewphto"
                         class="img"
                         alt="">
                </div>
                <div class="pages">
                    <Page :total="total"
                          :page-size="page"
                          show-total
                          show-elevator
                          @on-change="pagechange" />
                </div>
            </div>
        </Modal>
        <Modal v-model="modalview"
               width="auto"
               footer-hide>
            <img :src="url"
                 @mousewheel="mousewheel"
                 ref="img"
                 alt="">
        </Modal>
    </div>

</template>
<script>
import API from '@/service/api.js'
import loading from '@/views/components/basic/loading'
import nodata from '@/views/components/basic/nodata'
export default {
    name: 'viewContract',
    components: {
        loading,
        nodata
    },
    data () {
        return {
            viewmodal: false,
            modalview: false,
            loadingview: false,
            loading: false,
            total: 1,
            page: 1,
            url: '',
            contractObj: {},
            spintext: '文件加载中，由于文件过大，加载时间变长，请耐心等待....'
        }
    },
    mounted () {
        // this.pagechange(1)
    },
    methods: {
        open (data) {
            this.viewmodal = true
            this.initDate(data)
        },
        initDate (data) {
            this.loading = true
            const { contractId } = data
            this.axios.get(this.urlFormat(API.GET_CONTRACT_VIEW + '?contractId=' + contractId, false)).then(res => {
                if (res) {
                    this.loading = false
                    this.contractObj = res.filePath
                    this.total = res.fileSum
                    if (this.contractObj) {
                        this.pagechange(1)
                    }
                } else {
                    this.loading = false
                }
            }).catch(() => {
                this.loading = false
            })
        },
        pagechange (val) {
            const index = (val - 1) + ''
            this.loading = true
            this.axios.get(this.urlFormat(API.GET_CONTRACT_VIEWIMAGE + '?fileSum=' + encodeURIComponent(this.$encrypt(index)) + '&filePath=' + encodeURIComponent(this.contractObj), false), { responseType: 'blob' }).then(res => {
                // const blob = new Blob([res], { type: 'image/png' })
                this.url = window.URL.createObjectURL(res)
                this.loading = false
            }).catch(() => {
            })
        },
        viewphto () {
            this.modalview = true
        },
        mousewheel () {
            /* 获取当前页面的缩放比 若未设置zoom缩放比，则为默认100%，即1，原图大小 */
            let zoom = parseInt(this.$refs.img.style.zoom) || 100
            /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动 */
            zoom += event.wheelDelta / 12
            // if (zoom < 0) {
            //     this.$refs.img.style.cursor = 'zoom-out'
            // } else {
            //     this.$refs.img.style.cursor = 'zoom-in'
            // }
            /* 最小范围 和 最大范围 的图片缩放尺度 */
            if (zoom >= 100 && zoom < 500) {
                this.$refs.img.style.zoom = zoom + '%'
            }
            return false
        },
        cancel () {
            this.viewmodal = false
            this.url = ''
            this.total = 1
            this.page = 1
        }

    }
}
</script>
<style lang="less" >
html .ivu-modal-wrap .ivu-modal,
body .ivu-modal-wrap .ivu-modal {
    top: auto;
    max-height: 100%;
    max-width: 100% !important;
}
.view-contract {
    .ivu-modal-fullscreen {
        top: 50px !important;
    }
    .img-class {
        width: auto;
        text-align: center;
        .img {
            border: 1px solid #e9e9e9;
            cursor: zoom-in;
        }
        .no-data {
            text-align: center;
        }
    }
    .pages {
        width: 100%;
        position: fixed;
        bottom: 0;
        right: 0;
        border-top: 1px solid #e8e8e8;
        padding: 10px 16px;
        text-align: right;
        background: #fff;
    }
}
</style>
